export default __webpack_public_path__ + "static/media/arrow-mobile.ec403b09.svg";